import { combineReducers } from 'redux';

import * as types from 'modules/devices/actionTypes';
import type { Action } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';

const modalTypes: string[] = [
  types.OPEN_CREATE_DEVICE_MODAL,
  types.HIDE_CREATE_DEVICE_MODAL,
  types.SET_UPDATE_MODAL_VISIBILITY,
];

const abortMatcher = <T>(resetValue: T) => ({
  matcher: ({ type }: Action) => type === types.DEVICE_NAME_CHECK_ABORT,
  reducer: () => resetValue,
});

const resetErrorMatcher = {
  matcher: ({ type }: Action) => modalTypes.includes(type),
  reducer: () => null,
};

export default combineReducers({
  loading: loading(types.DEVICE_NAME_CHECK_REQUEST, { matchers: [abortMatcher(false)] }),
  // The saga dispatches a translation key here (deviceNameCheckFailure), not an ApiError.
  error: error<string>(types.DEVICE_NAME_CHECK_REQUEST, { matchers: [resetErrorMatcher, abortMatcher(null)] }),
});
